import { render, staticRenderFns } from "./listglobally.vue?vue&type=template&id=9d772b0c"
import script from "./listglobally.vue?vue&type=script&lang=js"
export * from "./listglobally.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports